/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const n=8388607,t=8388608,o=t=>t&n;function r(n,o){return((o?t:0)|n)>>>0}export{r as createDisplayId,n as displayIdTexelMask,t as displayIdTypeMask,o as getDisplayIdTexel};
